"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var VimeoSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.3424768,10.8675275 C10.5749854,13.1693224 9.07958573,14.3200898 7.85627783,14.3200898 C7.09876294,14.3200898 6.45720879,13.6193853 5.93356541,12.2174562 C5.58360315,10.9323979 5.23403089,9.64746965 4.88419863,8.36241135 C4.49510612,6.96126229 4.07793342,6.25977776 3.63190054,6.25977776 C3.53465991,6.25977776 3.19431772,6.46478909 2.61165395,6.87325173 L2,6.08375663 C2.64155414,5.51890298 3.27452823,4.95417933 3.89723226,4.38867568 C4.75289778,3.64780089 5.39523193,3.25818837 5.8233247,3.21879812 C6.83512123,3.12142749 7.45782526,3.81433197 7.69156677,5.29764155 C7.9441584,6.89795189 8.11887953,7.89336832 8.21716016,8.28298083 C8.50875205,9.61067941 8.82959412,10.2736837 9.18020638,10.2736837 C9.45229814,10.2736837 9.86102078,9.84312091 10.4059843,8.98199535 C10.9504278,8.12060978 11.2420197,7.46527555 11.28141,7.01508264 C11.3588905,6.27173784 11.0671686,5.89915543 10.4059843,5.89915543 C10.0947623,5.89915543 9.77392022,5.9709159 9.44384809,6.11274681 C10.0826722,4.01596327 11.3033801,2.99766669 13.1051917,3.05577707 C14.4409504,3.09503732 15.0706744,3.96305293 14.9937139,5.65995389 C14.9358636,6.92785208 14.0519879,8.66401329 12.3424768,10.8675275 Z" })));
};
VimeoSmall.displayName = 'VimeoSmall';
exports.default = VimeoSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=VimeoSmall.js.map